// extracted by mini-css-extract-plugin
export default {"wrap":"PaymentMethodSelectModal_wrap__tM2Tg","paymentMethodCard":"PaymentMethodSelectModal_paymentMethodCard__MFepJ","icon":"PaymentMethodSelectModal_icon__iL63L"};